import registerElement from './register-element';
export function registerApp(app) {
  registerElement(app);
}
